import { EmbeddedPlayer, ViewerStreamUrls } from 'features/viewerPage/viewerPage.interfaces'
import { MediaObject } from 'interfaces'
import { FC } from 'react'
import SolidsportVideoPlayer from './providers/SolidsportVideoPlayer/SolidsportVideoPlayer'
import { useFeatureFlags } from 'featureFlags/useFeatureFlags'
import { FeatureFlagsAvailable } from 'featureFlags/FeatureFlagsAvailable'
import { EmbeddedVideoPlayer } from './providers/EmbeddedVideoPlayer/EmbeddedVideoPlayer'


export type VideoPlayerProps = {
  mediaObject: MediaObject,
  streamUrls: ViewerStreamUrls
  embedded?: EmbeddedPlayer
  autoPlay: boolean
  seekTo?: number
}

export const VideoPlayer: FC<VideoPlayerProps> = ({
  mediaObject,
  streamUrls,
  embedded,
  autoPlay,
  seekTo = undefined
}) => {
  const { getFlag } = useFeatureFlags()

  if (embedded?.url && (embedded.enabled || getFlag(FeatureFlagsAvailable.EmbeddedVideoPlayer))) {
    return <EmbeddedVideoPlayer url={embedded.url} />
  }
  return <SolidsportVideoPlayer mediaObject={mediaObject} streamUrls={streamUrls} autoPlay={autoPlay} seekTo={seekTo} />
}
